import { STAFF_SUPPORT_EMAIL } from "../../../utils/userFacingError";

/**
 * Shown when an invoice or receipt email may have gone out but the result is
 * not known. Staff check the invoice first so it is not sent twice.
 */
export const INVOICE_EMAIL_UNCONFIRMED_TEXT = `We could not confirm that the email was sent. Check the invoice in Invoices & Payments > Manage all Invoices & Payments before you try again. If it keeps happening, email ${STAFF_SUPPORT_EMAIL}.`;

/**
 * Shown when the saved invoice has no valid email address, so Email is off.
 * The address is saved on the invoice; staff cannot add it after the invoice
 * is created (wave 2, audit row "A valid saved recipient is required").
 */
export const getInvoiceNoSavedEmailText = ({
  customerName,
  document,
  printLabel,
}: {
  customerName?: string | null;
  document: "invoice" | "payment receipt";
  /** The print button label on this screen, if the screen has one. */
  printLabel?: string;
}): string =>
  [
    `There is no valid email address saved on this invoice${
      customerName?.trim() ? ` for ${customerName.trim()}` : ""
    }, so we cannot email the ${document}.`,
    printLabel ? `Select ${printLabel} to print it instead.` : "",
    `To add an email address, email ${STAFF_SUPPORT_EMAIL}.`,
  ]
    .filter(Boolean)
    .join(" ");
